const o = "accordion", c = "magnet", n = "accordion__header", a = "accordion__badge", i = "accordion__icon", r = "accordion__panel", _ = "accordion__item", d = {
  accordion: o,
  magnet: c,
  "video-player": "video-player",
  accordion__header: n,
  "accordion__header-text": "accordion__header-text",
  "accordion__header-icons": "accordion__header-icons",
  accordion__badge: a,
  accordion__icon: i,
  "accordion__icon--chevron": "accordion__icon--chevron",
  "accordion__icon--chevron-open": "accordion__icon--chevron-open",
  accordion__panel: r,
  "accordion__panel-content": "accordion__panel-content",
  accordion__item: _,
  "accordion__item--active": "accordion__item--active",
  "accordion__item--closing": "accordion__item--closing",
  "accordion--compact": "accordion--compact",
  "accordion--no-margin": "accordion--no-margin",
  "accordion--no-border-top": "accordion--no-border-top",
  "accordion--no-border-bottom": "accordion--no-border-bottom"
};
export {
  o as accordion,
  a as accordion__badge,
  n as accordion__header,
  i as accordion__icon,
  _ as accordion__item,
  r as accordion__panel,
  d as default,
  c as magnet
};
